export default {
  left: {
    group: '我的分組',
    location: '日程地點',
    description: '日程說明',
    scoreChart: '評分表',
    scoreChartDescription: '評分表說明',
  },
  logout: '登出',
  right: {
    title: '面試官打分結果確認表',
    project: '項目',
    scheduleDate: '面試日期',
    scoreChart: '面試評分表',
    interviewer: '面試官',
    name: '面試名稱',
    placeholder: '全部安排',
  },
  footer: {
    tip: '請確認以上評分及評語無誤,確認簽字後,將不可修改。',
    signature: '面試官簽字',
    date: '日期',
    signatureButton: '請點擊此處進行簽字',
    signatureDraw: '請在此區域簽字',
    signatureConfirm: '請核對簽名後進行提交,提交後不可更改。',
    buttonConfirm: '確認提交',
    buttonClear: '清空',
    success: '感謝您完成任務',
    confirm: '確定',
  },
  titleShow: '面試官打分結果確認表',
  signOutConfirm: '確定退出面試評分系統？',
  signOutCancel: '取消退出',
  error401: '登入過期,請重新登入',
};
